<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">pending_actions</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Transacciones rezagadas</h1>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm" *ngIf="filterForm">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <!-- Date range -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Rango de fechas</mat-label>
            <mat-date-range-input [rangePicker]="datePicker">
              <input matStartDate formControlName="startDate" placeholder="Fecha inicial">
              <input matEndDate formControlName="endDate" placeholder="Fecha final">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #datePicker></mat-date-range-picker>
            <div *ngIf="(filterForm.get('endDate')?.value==null&&filterForm.get('startDate')!=null)||(filterForm.get('startDate')?.value==null&&filterForm.get('endDate')!=null)" class="text-red-500 text-xs mt-1">
              Seleccionar fecha inicial y fecha final.
            </div>
          </mat-form-field>

          <!-- Hora inicial -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Hora inicial</mat-label>
            <mat-select formControlName="startTime" placeholder="Hora inicial" (selectionChange)="updateEndTimeOptions()">
              <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
            </mat-select>
            <div *ngIf="(filterForm.get('startTime')?.value==undefined&&filterForm.get('endTime')?.value!=undefined)" class="text-red-500 text-xs mt-1">
              Ingresar hora inicial.
            </div>
          </mat-form-field>

          <!-- Hora final -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Hora final</mat-label>
            <mat-select formControlName="endTime" placeholder="Hora final">
              <ng-container *ngFor="let hour of hours; let i = index">
                <mat-option *ngIf="i >= hours.indexOf(filterForm.get('startTime')?.value || '')" [value]="hour">{{ hour }}</mat-option>
              </ng-container>
            </mat-select>
            <div *ngIf="(filterForm.get('endTime')?.value==undefined&&filterForm.get('startTime')?.value!=undefined)" class="text-red-500 text-xs mt-1">
              Ingresar hora final.
            </div>
          </mat-form-field>

          <!-- Cuenta Destino -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Cuenta Destino</mat-label>
            <input matInput formControlName="destAcc" placeholder="Cuenta Destino">
          </mat-form-field>

          <!-- RUT -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>RUT</mat-label>
            <input matInput formControlName="rut" placeholder="RUT">
          </mat-form-field>

          <!-- Cuenta Origen -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Cuenta Origen</mat-label>
            <input matInput formControlName="originAcc" placeholder="Cuenta Origen">
          </mat-form-field>

          <!-- Nombre Origen -->
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Nombre Origen</mat-label>
            <input matInput formControlName="name" placeholder="Nombre Origen">
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="button" (click)="loadTransactions()"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Filtrar
          </button>
          <button type="button" (click)="clearFilters()"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar Filtros
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Paginator -->
  <div class="mb-4">
    <mat-paginator #paginator
      (page)="onPageChange($event)"
      [length]="totalItems"
      [pageSize]="pageSize"
      [disabled]="false"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [hidePageSize]="false"
      [pageIndex]="currentPage-1"
      aria-label="Select page">
    </mat-paginator>
  </div>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="dataSource">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full">

        <ng-container matColumnDef="codigoTransferencia">
          <th mat-header-cell *matHeaderCellDef>Referencia</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.codigoTransferencia }}</span></td>
        </ng-container>

        <ng-container matColumnDef="bancoOrigen">
          <th mat-header-cell *matHeaderCellDef>Banco Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.bancoOrigen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="tipoCuentaOrigen">
          <th mat-header-cell *matHeaderCellDef>Tipo Cta. Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.tipoCuentaOrigen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="numeroCuentaOrigen">
          <th mat-header-cell *matHeaderCellDef>Cta. Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.numeroCuentaOrigen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="numeroCuentaDestino">
          <th mat-header-cell *matHeaderCellDef>Cta. Destino</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.cuentaCorriente }}</span></td>
        </ng-container>

        <ng-container matColumnDef="rutOrigen">
          <th mat-header-cell *matHeaderCellDef>RUT Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.rutOrigen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="nombreOrigen">
          <th mat-header-cell *matHeaderCellDef>Nombre Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.nombreOrigen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="fechaContable">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.fechaContable }}</span></td>
        </ng-container>

        <ng-container matColumnDef="hora">
          <th mat-header-cell *matHeaderCellDef>Hora</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.hora }}</span></td>
        </ng-container>

        <ng-container matColumnDef="moSaldoCargo">
          <th mat-header-cell *matHeaderCellDef>Cargo</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs" style="color: #dc2626;">{{ row.moSaldoCargo | currency:'$' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="moSaldoAbono">
          <th mat-header-cell *matHeaderCellDef>Abono</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" style="color: #1e5a3f;">{{ row.moSaldoAbono | currency:'$' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="width: 80px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let element" style="width: 80px; text-align: center;">
            <button *ngIf="element.moSaldoAbono > 0" title="Asignar" (click)="assignDialog(element)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
              onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">assignment_add</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3" *ngIf="dataSource">
    <div *ngFor="let row of dataSource.filteredData; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="text-xs font-mono font-semibold text-gray-600 shrink-0">{{ row.codigoTransferencia }}</span>
          <span class="text-xs text-gray-700 truncate">{{ row.nombreOrigen }}</span>
          <span class="text-xs font-bold shrink-0" style="color: #1e5a3f;">{{ row.moSaldoAbono | currency:'$' }}</span>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Banco Origen</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.bancoOrigen }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Cta. Origen</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.tipoCuentaOrigen }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cta. Origen</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row.numeroCuentaOrigen }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cta. Destino</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row.cuentaCorriente }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">RUT Origen</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.rutOrigen }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha / Hora</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.fechaContable }} {{ row.hora }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cargo</span>
            <p class="font-medium mt-0.5" style="color: #dc2626;">{{ row.moSaldoCargo | currency:'$' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Abono</span>
            <p class="font-bold mt-0.5" style="color: #1e5a3f;">{{ row.moSaldoAbono | currency:'$' }}</p>
          </div>
        </div>
        <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100" *ngIf="row.moSaldoAbono > 0">
          <button title="Asignar" (click)="assignDialog(row)"
            style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #16a34a;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #16a34a;">assignment_add</mat-icon>
            Asignar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
